export enum DropdownTypeId {
  Relationship = 1,
  Title = 2,
  Gender = 3,
  MaritialStatus = 4,
  Religion = 5,
  Region = 6,
  State = 7,
  Country = 8,
  Nationality = 9,
  ApplicantType = 10,
  PaymentTransactionType = 12,
  SanjeevaniTransactionType = 18,
}
